const initialEditorState = () => ({
  password: '',
  passwordConfirm: '',
});

export default initialEditorState;
